import { AuthContainer } from "@memorang/ui";
import EmailForm from "./EmailForm";

interface Props {
	handleSubmit: (email: string, password?: string) => void;
	loading?: boolean;
	emailFromUrl?: string;
	lastLoggedInEmail?: string;
	tos?: string;
	privacy?: string;
	showPasswordField?: boolean;
	onChangeEmail?: (email: string) => void;
}

const EmailView = ({
	handleSubmit,
	loading,
	emailFromUrl,
	lastLoggedInEmail,
	tos,
	privacy,
	showPasswordField,
	onChangeEmail,
}: Props) => {
	return (
		<>
			<AuthContainer>
				<EmailForm
					loading={loading}
					handleSubmitEmail={handleSubmit}
					emailFromUrl={emailFromUrl}
					lastLoggedInEmail={lastLoggedInEmail}
					tos={tos}
					privacy={privacy}
					showPasswordField={showPasswordField}
					onChangeEmail={onChangeEmail}
				/>
			</AuthContainer>
		</>
	);
};

export default EmailView;
